import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//actions
import { closeAuditModal, SearchJobAuditItems } from '../../actions/jobRangeDetails';
import JobAudit from '../../../../JobAudit/JobAudit';

const propTypes = {};

export class JBRAuditModal extends Component {
  render() {
    return <JobAudit {...this.props} />;
  }
}

JBRAuditModal.propTypes = propTypes;

const connectState = state => {
  try {
    const { job, auditItems, auditModalIsOpen } = state.jobRanges.jobRangeDetails;
    return {
      job,
      auditItems: auditItems.filter(({ meta: { org_job_code, org_job_code_key } }) => {
        return org_job_code === job.org_job_code && org_job_code_key === job.org_job_code_key;
      }),
      isOpen: auditModalIsOpen
    };
  } catch (err) {
    console.log('get state error ', err);
  }
};
const actions = { close: closeAuditModal, search: SearchJobAuditItems };
export default connect(connectState, actions)(JBRAuditModal);
